<template>
  <header>
    <div class="nav">
      <a href="https://derosso.com.br">
          <img src="@/assets/logotipo-derosso-site-branco.png" alt="DeRosso" width="140" height="24"/>
        </a>
        <div class="btn mt-3">
          <a href="https://derosso.com.br">Voltar ao site</a>
        </div>
    </div>
    <div class="info">
      <span>Onde</span>
      <h1>Encontrar</h1>
      <p>Estamos comprometidos em tornar sua experiência excepcional, conectando você à qualidade e sofisticação que a DeRosso oferece. Preencha o formulário abaixo para descobrir a localização da loja parceira mais próxima de você. </p>
    </div>
  </header>
</template>

<script>
import Events from '../shared/events';

export default {
  name: 'header-component',
  props: {
    msg: String
  },
  data() {
    return {
      language: this.$route.params.language,
    }
  },
  methods: {
    handlerTranslate(event) {
      this.$router.push({ params: { language: event.target.value } });
      Events.$emit('change_translate', event.target.value);
    }
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
header {
  flex-direction: column;
  width: 100%;
  padding-right: 16px;
  display: flex;
  height: auto;
  align-items: center;
  background-image: url("../assets/banner.jpg");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  .info {
    margin: 4rem 34rem 4rem 0rem;
    width: fit-content;
  }
  .info span{
    text-transform: uppercase;
    color: #fff;
    letter-spacing: 4.8px;
    font-weight: 500;
    font-size: 16px;
    font-family: "Oswald", Sans-serif;
  }
  .info h1{
    text-transform: uppercase;
    color: #fff;
    line-height: 80px;
    margin: 0px;
    font-size: 80px;
    font-weight: 500;
    letter-spacing: 2.2px;
    font-family: "Oswald", Sans-serif;
  }
  .info p {
    text-align: left;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #ABABAB;
    font-family: "Montserrat-Regular", Sans-serif;
    max-width: 20rem;
  }
  .nav {
    background: #333;
    width: 60rem;
    height: 6rem;
    margin: 1.6rem 0;
    padding: 2rem 1.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .btn {
    padding: 0 15px;
    letter-spacing: 1.5px;
    a {
      font-weight: 500;
      width: 100%;
      display: block;
      color: white;
      font-size: 14px;
      text-align: center;
      text-transform: uppercase;
      text-decoration: none;
      padding: 0.6rem;
    }
  }
}

@media screen and (max-width: 1025px) {
  header {
    padding: 0 1rem;
    margin: 0;
    background-image: none;

    .btn {
      padding: 0 8px;
      letter-spacing: 0px;
      a {
        text-wrap: nowrap;
        padding: 0.4rem 0;
      }
    }
    .info {
      margin: 0;
      width: 100%;
      background-color: #1d1d1d;
      padding: 4rem 1rem;
      background-image: url("../assets/banner-responsivo.jpg");
      background-position: right;
      background-repeat: no-repeat;
      background-size: 25rem;
      background-origin: content-box;
    }
    .info p {
      max-width: 20rem;
    }
    .info h1 {
      font-size: 56px;
      line-height: 4rem;
    }
    .nav {
      width: 100%;
      background-color: #272727;
    }
  }
}

@media screen and (max-width: 800px) {
  header {
    padding: 0;
    .info {
      background-image: none;
    }
    .nav {
    margin: 0;

    }
  }
}
</style>
